const A="en";export{A as DEFAULT_LANGUAGE_TEMPLATE};
//# sourceMappingURL=constants.js.map
